/**
 * Log a playback error to the server telemetry endpoint.
 *
 * Replicates the behaviour of `logPlaybackErrorTelemetry()` in
 * `player_utils.js` — first probes the CDN URL with a Range request to
 * capture the HTTP status, then POSTs the error details to the server.
 */
export async function logPlaybackError(cdnUrl: string, fileId: number, mime_type: string): Promise<void> {
  let httpStatus: number | null = null;
  let body: string | null = null;

  try {
    const res = await fetch(cdnUrl, {
      method: 'GET',
      headers: { Range: 'bytes=0-1' },
    });
    httpStatus = res.status;

    try {
      body = await res.text();
    } catch (inner: any) {
      body = `Could not read body: ${inner.message}`;
    }
  } catch (fetchErr: any) {
    httpStatus = -1;
    body = `Fetch failed: ${fetchErr.message}`;
  }

  try {
    await fetch('/logging/playback-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json; charset=UTF-8' },
      body: JSON.stringify({
        cdn_url: cdnUrl,
        page_url: window.location.href,
        status_code: httpStatus,
        file_id: fileId,
        mime_type: mime_type,
        body,
      }),
    });
  } catch (telemetryErr: any) {
    console.error(`[KollabPlayer] Telemetry send failed: ${telemetryErr.message}`);
  }
}
